import { Component, Inject, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { assetsConst } from 'src/app/core/const/assets.const';

@Component({
  selector: 'megastore-admin-view-image',
  templateUrl: './view-image.component.html',
  styleUrls: ['./view-image.component.scss']
})
export class ViewImageComponent {
  assetsConst = assetsConst;
  @Input() image: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    public dialogRef: MatDialogRef<ViewImageComponent>
  ) {
    this.image = data;
  }
}
